<template>
  <div>
    <form @submit.prevent="handleSubmit">
      <div class="row">
        <div
          :class="{
            ['col-lg-6 col-6']: podeCriar,
            ['col-lg-7 col-6']: !podeCriar,
          }"
        >
          <h4>
            <span class="md-display-1">{{ titulo }}</span>
          </h4>
        </div>
        <div v-if="podeCriar || false" class="col-lg-2 col-6">
          <h4>
            <md-button class="md-primary md-raised" @click.stop="openCriar">
              Cadastrar
            </md-button>
          </h4>
        </div>
        <div class="col-6 col-md-2">
          <md-field>
            <label :for="`local${_uid}`">{{ tituloFiltro }}</label>
            <md-input
              :id="`local${_uid}`"
              v-model="filtro"
              name="local"
              :disabled="enviando || false"
            />
          </md-field>
        </div>
        <div class="col-6 col-md-2">
          <h4>
            <md-button
              type="submit"
              class="md-primary"
              :disabled="enviando || false"
            >
              Buscar
            </md-button>
          </h4>
        </div>
      </div>
    </form>
    <md-divider />
    <br />
  </div>
</template>

<script>
export default {
  name: 'FiltroRapido',
  props: {
    enderecoFiltro: {},
    titulo: String,
    tituloFiltro: String,
    enviando: Boolean,
    novo: {
      toRoute: String,
      routeBack: String,
    },
    podeCriar: Boolean,
    emitEventAndSupresRoutePush: Boolean,
  },
  data() {
    return {
      filtro: '',
    }
  },
  methods: {
    openCriar(e) {
      if (this.emitEventAndSupresRoutePush) {
        this.$emit('onClickCreate', e)
        return
      }

      this.$router.push({ name: this.novo.toRoute, params: { ...this.novo } })
    },
    handleSubmit() {
      this.$emit('onSubmit', this.filtro)
    },
  },
}
</script>
